<div class="d-flex flex-row bd-highlight mb-3">
  <div class="p-2">
    <strong>SPW {{preview.index}}</strong>:
    {{preview.freqMin | number}}..{{preview.freqMax | number}}GHz, {{preview.resMax | number}}
    kHz, {{preview.polProduct}}
    <ng-container *ngIf="!preview.thumbnailFile; then thumbnailNoAvailable else thumbnail"></ng-container>
  </div>
  <div class="d-flex flex-column p-2">
    <i *ngIf="preview.previewFile"
       id="{{'previews-interactive-file-' + preview.previewFile}}"
       class="fa-light fa-images mb-2"
       style="font-size: 1.5rem;cursor: pointer"
       placement="right"
       [ngbTooltip]="'Interactive preview'"
       (click)="openFileInANewTab(preview.previewFile)"></i>
    <i *ngIf="preview.imageFile"
       id="{{'previews-image-file-' + preview.imageFile}}"
       class="fa-light fa-image mb-2"
       style="font-size: 1.5rem;cursor: pointer"
       placement="right"
       [ngbTooltip]="'PNG preview file'"
       (click)="openFileInANewTab(preview.imageFile)"></i>
    <img *ngIf="preview.previewFile"
         id="{{'previews-carta-file-' + preview.previewFile}}"
         class="py-1"
         src="assets/images/carta_logo.png"
         style="cursor: pointer"
         placement="right"
         [ngbTooltip]="'CARTA'"
         (click)="emitOpenCarta()">
  </div>
  <div class="p-2">
    <div *ngIf="preview.fitsFile" class="text-nowrap mb-2">
      <a id="{{'previews-fits-file-' + preview.fitsFile}}"
         href="{{asaxPropertiesService.getProperties().dataPortalUrl}}/{{preview.fitsFile}}" class="link-primary me-4">
        {{preview.fitsFile}}
      </a>
      {{preview.fitsFileSize | bytes }}
    </div>
    <ul class="list list-unstyled text-nowrap">
      <li><strong>Band</strong>: {{preview?.band}}</li>
      <li><strong>Frequency type</strong>: {{preview?.chaNum | frequencyType}}</li>
      <li><strong>Frequency range</strong>: {{preview?.freqMin | number}}..{{preview?.freqMax | number}}</li>
      <li><strong>Frequency resolution</strong>: {{preview?.resMax | number}} kHz</li>
      <li><strong>Continuum sensitivity</strong>: {{preview?.continuumSensitivity | number}}</li>
      <li><strong>Line sensitivity 10km/s (estimate)</strong>: {{preview?.sens10 | number}} mJy/beam@10km/s</li>
      <li><strong>Line sensitivity native (estimate)</strong>: {{preview?.sensBand | number}} uJy/beam@native</li>
      <li><strong>Polaritazions</strong>: {{preview?.polProduct}}</li>
      <li><strong>Array</strong>: {{preview?.array}}</li>
    </ul>
  </div>
</div>

<ng-template #thumbnail>
  <div class="border rounded">
    <div class="d-flex justify-content-center align-items-center"
         [style.width.px]="previewWidth"
         [style.height.px]="previewHeight">
      <img id="{{'previews-image-' + thumbnailFile}}"
           *ngIf="thumbnailFile" [src]="thumbnailFile | safe : 'resourceUrl'"
           style="cursor: pointer;"
           (click)="openFileInANewTab(preview.previewFile)">
      <div *ngIf="!thumbnailFile" class="spinner-border spinner-border-sm">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #thumbnailNoAvailable>
  <div class="border rounded">
    <div class="d-flex justify-content-center align-items-center"
         [style.width.px]="previewWidth"
         [style.height.px]="previewHeight">
      preview not available
    </div>
  </div>
</ng-template>


